<div class="tile">
  <div class="row">
    <div class="col-12">
      <h5>{{ 'statistics.my-news.headline' | transloco }}</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mt-4">
      <table class="table-depot mb-0" aria-describedby="my-news">
        @if (!loading) {
          @if (news?.length) {
            @for (item of news | slice: 0 : 5; track $index) {
              <tr data-zid="news-item">
                <td class="font-medium font-size-smaller1">
                  <a [href]="item.sourceUri" class="zero-text default" target="_blank" rel="noopener noreferrer">
                    {{ item.title.length > 75 ? (item.title | slice: 0 : 75) + '...' : item.title }}
                  </a>
                </td>
              </tr>
            }
          } @else {
            <div data-zid="no-data">{{ 'statistics.my-news.no-data' | transloco }}</div>
          }
        } @else {
          @for (_ of [1, 2, 3, 4, 5]; track $index) {
            <tr>
              <td>
                <div class="loading-shimmer trade-tick"></div>
              </td>
            </tr>
          }
        }
      </table>
    </div>
  </div>
</div>
